import React from "react";
import classNames from "classnames";
import { injectIntl } from "react-intl";
var SocialAppHeader = function(param) {
    var _param_hero = param.hero, hero = _param_hero === void 0 ? false : _param_hero, children = param.children;
    var classes = classNames("social-app-header", {
        "social-app-header--hero": hero
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classes
    }, /*#__PURE__*/ React.createElement("div", {
        className: "social-app-header__content"
    }, children));
};
export default injectIntl(SocialAppHeader);
